import { Pipe, PipeTransform } from '@angular/core';

export interface TelephoneLink {
  number: string;
  href: string;
}

/*
  Splitter en kommaseparert telefonstreng og returnerer lenker klar for tel:-bruk.
  Hvis et nummer ikke starter på + legges standard landskode foran i href-en.
*/
@Pipe({ name: 'telephone', standalone: true })
export class TelephonePipe implements PipeTransform {

  transform(input: any, defaultDialCode: string = '+47'): TelephoneLink[] {
    if (input == null || input === '') {
      return [];
    }

    const value = typeof input === 'string' ? input : String(input);

    return value
      .split(/[,;]/)
      .map(part => part.trim())
      .filter(part => part.length > 0)
      .map(part => {
        const digits = part.replace(/\s/g, '');
        const hrefNumber = digits.startsWith('+') ? digits : `${defaultDialCode}${digits}`;
        return { number: part, href: `tel:${hrefNumber}` };
      });
  }
}
